import FadedText from "@components/FadedText";
import { Card } from "@components/Layout";
import { Image } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const PlayableTrackCard = styled(Card)<{ even?: boolean; blur?: boolean; playing?: boolean }>`
  ${({ even, theme }) => (even ? `background: ${theme?.tracklist.trackEven} !important;` : "")}
  ${({ blur }) => (blur ? "filter: blur(10px);" : "")}
  ${({ playing, theme }) => (playing ? `box-shadow: ${theme?.tracklist.shareShadow};` : "")}
`;

export const TrackImage = styled(Image.Root)<{ clickable?: boolean }>`
  height: 115px;
  width: 115px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
  ${({ clickable }) => (clickable ? "cursor:pointer;" : "")}
  & > * {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 1024px) {
    width: 40px;
    height: 40px;
  }
`;
export const TrackName = styled(FadedText)`
  @media only screen and (max-width: 1024px) {
    font-size: 15px;
  }
`;
export const AuthorName = styled(FadedText)`
  @media only screen and (max-width: 1024px) {
    font-size: 12px;
  }
`;
